module.exports = __webpack_public_path__ + "media/target_area_icon/dept_logistics-d806d4e9.png";